export default __webpack_public_path__ + "static/media/wall1.7570b5c4.jpg";